module.exports = __webpack_public_path__ + "img/logo.884a8a5c.svg";